import {
    IN_CURRENCY_ACTION,
    OUT_CURRENCY_ACTION,
    NOT_ACTIVE_IN_CURRENCY_ACTION,
    NOT_ACTIVE_OUT_CURRENCY_ACTION,
    AMOUNT_ACTION,
    IN_CURRENCY_SHOW_ACTION,
    OUT_CURRENCY_SHOW_ACTION,
    CLOSE_MODAL_ACTION,
    IN_CURRENCY_COIN,
    OUT_CURRENCY_COIN,
    SEARCH_MODAL_IN_ACTION,
    SEARCH_MODAL_OUT_ACTION,
    PAYWAY_ACTION,
    FAIL_PROVIDERS,
    NEXT_SCREEN,
    PROVIDER_ACTION,
    BACK_FIRST_SCREEN_ACTION,
    MIN_MAX_HALF_ACTION,
    LIMITS_ARRAY_ACTION,
    MODAL_ERROR_ACTION,
    CREATED_ORDER_ERROR,
    EXPIRATED_RATE,
    ORDER_ACTION,
    ORDER_CREATED_ACTION,
    LOADING_ACTION,
    CARD_DATA,
    CARD_COUNTRY_CODE,
    COUNTRY_SHOW,
    ONE_TIME_CARD,
    ADD_CARD,
    SEARCH_MODAL_COUNTRY_ACTION,
    NEED_VERIFICATION,
    SEARCH_MODAL_PAYWAY_ACTION,
    MOBILE_PHONE,
    MODAL_SERVER,
    COMING_SOON_ACTION,
    SKIP_PAYMENT_DETAILS,
    ADVANCED_CLOSE_ACTION,
    VALIDATION_OUT_DESTINATION_ACTION,
    OUT_DESTINATION_TIME_ACTION,
    OUT_DESTINATION_SHOW_ACTION,
    NEW_OUT_DESTINATION_ACTION,
    OUT_DESTINATION_ACTION,
    DESTINATION_TAG_ACTION,
    POST_MESSAGE_ERROR,
    BALANCE_HODL_MSG
} from '../type'

export function inCurrencyAction(inCurrency) {
    return {
        type: IN_CURRENCY_ACTION,
        inCurrency
    }
}

export function notActiveInCurrencyAction(inCurrency) {
    return {
        type: NOT_ACTIVE_IN_CURRENCY_ACTION,
        inCurrency,
    }
}

export function outCurrencyAction(outCurrency, minMaxLimits, outDestination, walletName) {
    return {
        type: OUT_CURRENCY_ACTION,
        outCurrency,
        minMaxLimits,
        outDestination,
        walletName
    }
}

export function notActiveOutCurrencyAction(outCurrency, outDestination, walletName) {
    return {
        type: NOT_ACTIVE_OUT_CURRENCY_ACTION,
        outCurrency,
        outDestination,
        walletName
    }
}

export function amountAction(amount, equivalent = null, timerId = null, providersArray = [], amountValid = false, amountHaveValid = false, loading = false, side = null, maxLimit = false) {
    return {
        type: AMOUNT_ACTION,
        amount,
        equivalent,
        timerId,
        providersArray,
        amountValid,
        amountHaveValid,
        loading,
        side,
        maxLimit
    }
}

export function minMaxHalfAction(minMaxHalf, minMaxLimits) {
    return {
        type: MIN_MAX_HALF_ACTION,
        minMaxHalf,
        minMaxLimits
    }
}

export function limitsArrayAction(minMaxLimits, limitsTimerId) {
    return {
        type: LIMITS_ARRAY_ACTION,
        minMaxLimits,
        limitsTimerId
    }
}

export function inCurrencyShowAction(paywayShow) {
    return {
        type: IN_CURRENCY_SHOW_ACTION,
        paywayShow
    }
}

export function outCurrencyShowAction() {
    return {
        type: OUT_CURRENCY_SHOW_ACTION,
    }
}


export function closeModalAction() {
    return {
        type: CLOSE_MODAL_ACTION
    }
}

export function inCurrencyCoinAction(inCurrencyActive, inCurrencyNotActive) {
    return {
        type: IN_CURRENCY_COIN,
        inCurrencyActive,
        inCurrencyNotActive
    }
}

export function outCurrencyCoinAction(outCurrencyActive, outCurrencyNotActive) {
    return {
        type: OUT_CURRENCY_COIN,
        outCurrencyActive,
        outCurrencyNotActive
    }
}

export function searchInputModalInAction(searchValue) {
    return {
        type: SEARCH_MODAL_IN_ACTION,
        searchValue,
    }
}

export function searchInputModalOutAction(searchValue) {
    return {
        type: SEARCH_MODAL_OUT_ACTION,
        searchValue,
    }
}

export function paywayMethodAction(payway, minMaxLimits) {
    return {
        type: PAYWAY_ACTION,
        payway,
        minMaxLimits,
        amountValid: false,
        amountHaveValid: false,
    }
}

export function providersStatusAction(failProviders, rateProvider = null) {
    return {
        type: FAIL_PROVIDERS,
        failProviders,
        rateProvider
    }
}

export function providerAction(provider, skipPaymentDetailsScreen) {
    return {
        type: PROVIDER_ACTION,
        provider,
        skipPaymentDetailsScreen
    }
}

export function nextAction(screen) {
    return {
        type: NEXT_SCREEN,
        screen
    }
}

export function backFirstScreenAction() {
    return {
        type: BACK_FIRST_SCREEN_ACTION,
    }
}

export function modalErrorAction(modalError, textError=null) {
    return {
        type: MODAL_ERROR_ACTION,
        modalError,
        textError
    }
}

export function orderCreatedAction() {
    return {
        type: ORDER_CREATED_ACTION
    }
}

export function createdOrderErrorAction(createdOrderError) {
    return {
        type: CREATED_ORDER_ERROR,
        createdOrderError
    }
}

export function expiratedRateAction(expiratedRate) {
    return {
        type: EXPIRATED_RATE,
        expiratedRate
    }
}

export function orderAction(order) {
    return {
        type: ORDER_ACTION,
        order
    }
}

export function loadingAction(loading) {
    return {
        type: LOADING_ACTION,
        loading
    }
}

export function cardNumberAction(cardData) {
    return {
        type: CARD_DATA,
        cardData
    }
}

export function cardCountrySelector(cardCountryCode) {
    return {
        type: CARD_COUNTRY_CODE,
        cardCountryCode
    }
}

export function countryShowAction(countryShow) {
    return {
        type: COUNTRY_SHOW,
        countryShow
    }
}

export function oneTimeCardAction(oneTimeCard) {
    return {
        type: ONE_TIME_CARD,
        oneTimeCard
    }
}

export function addCardAction (cards) {
    return {
        type: ADD_CARD,
        cards
    }
}

export function searchInputModalCountryAction (searchValueCountry) {
    return {
        type: SEARCH_MODAL_COUNTRY_ACTION,
        searchValueCountry
    }
}

export function searchPaywayAction (searchValuePayway) {
    return {
        type: SEARCH_MODAL_PAYWAY_ACTION,
        searchValuePayway
    }
}

export function needVerificationAction (needVerification) {
    return {
        type: NEED_VERIFICATION,
        needVerification
    }
}

export function mobilePhoneAction (mobilePhone) {
    return {
        type: MOBILE_PHONE,
        mobilePhone
    }
}

export function modalServerAction (modalServer, textError=null) {
    return {
        type: MODAL_SERVER,
        modalServer,
        textError
    }
}

export function comingSoonAction (comingSoon) {
    return {
        type: COMING_SOON_ACTION,
        comingSoon
    }
}

export function skipPaymentDetailsScreenAction (skipPaymentDetailsScreen) {
    return {
        type: SKIP_PAYMENT_DETAILS,
        skipPaymentDetailsScreen
    }
}

export function advancedCloseAction(newOutDestination) {
    return {
        type: ADVANCED_CLOSE_ACTION,
        newOutDestination
    }
}

export function validationOutDestinationAction(destinationValid, destinationError=false) {
    return {
        type: VALIDATION_OUT_DESTINATION_ACTION,
        destinationValid,
        destinationError
    }
}

export function outDestinationTimeAction(outDestination) {
    return {
        type: OUT_DESTINATION_TIME_ACTION,
        outDestination
    }
}

export function outDestinationShowAction() {
    return {
        type: OUT_DESTINATION_SHOW_ACTION,
    }
}

export function newOutDestinationAction() {
    return {
        type: NEW_OUT_DESTINATION_ACTION
    }
}

export function outDestinationAction(outDestination, walletName) {
    return {
        type: OUT_DESTINATION_ACTION,
        outDestination,
        walletName,
    }
}

export function destinationTagAction(destinationTag) {
    return {
        type: DESTINATION_TAG_ACTION,
        destinationTag
    }
}

export function postMessageErrorAction (postMessageError) {
    return {
        type: POST_MESSAGE_ERROR,
        postMessageError
    }
}

export function balanceHodlMsgAction(balanceHodlMsg) {
    return {
        type: BALANCE_HODL_MSG,
        balanceHodlMsg
    }
}